import { useEffect } from "react";

import {
  setAutoOpenJobReviewsModal,
  showWriteReviewFormAfterOpen,
} from "@js/apps/reviews/slice";
import { useAppDispatch, useQueryParams } from "@js/hooks";
import type { EmployerPublicProfile } from "@js/types/employer";
import type { FreelancerPublic } from "@js/types/freelancer";

export const useAutomaticallyOpenWriteReviewModal = ({
  profile,
}: {
  profile: FreelancerPublic | EmployerPublicProfile;
}) => {
  const dispatch = useAppDispatch();
  const query = useQueryParams();

  const canOpenReviewModal = !!(
    profile.can_user_review_job || profile.review_count
  );

  const contentType = query.content_type as
    EnumType<typeof ENUMS.ReviewType> | undefined;

  useEffect(() => {
    const writeReview = query.write_review as string | undefined;

    if (
      contentType === ENUMS.ReviewType.COWORKER_REVIEW ||
      contentType === ENUMS.ReviewType.EMPLOYMENT_REVIEW ||
      contentType === ENUMS.ReviewType.WORK_REVIEW ||
      contentType === undefined
    ) {
      if (writeReview?.toLowerCase() === "true" && canOpenReviewModal) {
        dispatch(setAutoOpenJobReviewsModal(true));
        dispatch(showWriteReviewFormAfterOpen(true));
      }
    }
  }, [query.write_review, canOpenReviewModal, dispatch, contentType]);
};
